import React, { CSSProperties } from 'react'
import { Divider as MaterialDivider, Typography } from '@mui/material'
import { CssStyles } from '../../types'
import { getClassName, parseClassNames } from '../../utils'
import { cx } from '@emotion/css'

export interface IDivider {
  /**
   * If true, divider will have proper size when used inside a flexbox container.
   * @default false
   */
  flexItem?: boolean

  /**
   * If true, divider will have lighter color.
   * @default false
   */
  light?: boolean

  /**
   * Orientation of the divider.
   * @default "horizontal"
   */
  orientation?: 'horizontal' | 'vertical'

  /**
   * Alignment of the label, if provided.
   */
  textAlign?: 'center' | 'left' | 'right'

  /**
   * Label of the component.
   */
  label?: string

  /**
   * Variant of the component.
   * @default "fullWidth"
   */
  variant?: 'fullWidth' | 'inset' | 'middle'

  /** *Deprecated* Raw CSS styles
   * @deprecated
   */
  styles?: CssStyles<'root' | 'label'>

  style?: CSSProperties | string
  labelStyle?: CSSProperties | string
}

export const Divider = React.forwardRef<HTMLHRElement, IDivider>(
  ({ label, styles, style, labelStyle, ...rest }, ref) => {
    const classNames = styles && parseClassNames(styles)

    if (label) {
      return (
        <MaterialDivider
          ref={ref}
          {...rest}
          className={cx(classNames?.root, getClassName(style))}
        >
          <Typography
            variant="body2"
            className={cx(classNames?.label, getClassName(labelStyle))}
          >
            {label}
          </Typography>
        </MaterialDivider>
      )
    }
    return (
      <MaterialDivider
        ref={ref}
        {...rest}
        className={cx(classNames?.root, getClassName(style))}
      />
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  Divider.displayName = 'Divider'
}
